import Text, { TextProps } from "@ui-kit/typography/Text/Text.web";
import { enums } from "@shared/constants";
import { PublicMembershipGroupSerializer } from "@shared/modules/memberships/types";
import { useTranslation } from "@shared/utils/internationalization";
import { ReactElement } from "react";

export type MembershipRenewalTextProps = {
  renewalFrequency: PublicMembershipGroupSerializer["renewal_frequency"];
};

export default function MembershipRenewalText({
  renewalFrequency,
  ...props
}: MembershipRenewalTextProps & TextProps): ReactElement {
  const { t } = useTranslation("purchases");
  // Get the text associated with the membership renewal frequency badge
  const getRenewalText = (
    renewalFrequency: PublicMembershipGroupSerializer["renewal_frequency"]
  ) => {
    const renewalObj = enums.RENEWAL_FREQUENCIES_MAP_BY_LIST.find(
      (renewalItem) => renewalItem.id === renewalFrequency
    );

    // if the renewal frequency is "Lifetime", return "Lifetime Membership"
    if (renewalObj?.id === enums.RENEWAL_FREQUENCIES_MAP_BY_ID.lifetime.id) {
      return `${t(renewalObj.name, { ns: "constants" })} ${t("Membership")}`;
    }

    // if the renewal frequency is "One time", return "One Time"
    if (renewalObj?.id === enums.RENEWAL_FREQUENCIES_MAP_BY_ID.one_time.id) {
      return t(renewalObj.name);
    }

    // default text format is "Renews Monthly", "Renews Yearly", etc
    return renewalObj
      ? `${t("Renews", { ns: "purchases" })} ${t(renewalObj.name, {
          ns: "constants",
        })}`
      : "";
  };
  return <Text {...props}>{getRenewalText(renewalFrequency)}</Text>;
}
